const styles = (theme) => {
  return {
    root: {},
    homeRoot: {}
  };
};

export default styles;
